export default __webpack_public_path__ + "static/media/top-arrow(2).56b11f7c.svg";